interface GoogleConfig {
  API_KEY: string;
  CLIENT_ID: string;
  SECRET: string;
  GOOGLE_REDIRECT_API: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  api: ApiConfig;
  app: {
    CLIENT_ID: string;
    CLIENT_SECRET: string;
    VENDOR_GUID: string;
  };
}

const config: Config = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
    GOOGLE_REDIRECT_API: process.env.REACT_APP_REDIRECT_URL || ""
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: process.env.REACT_APP_API_URL || "",
  },
  app: {
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID || "",
    CLIENT_SECRET:process.env.REACT_APP_CLIENT_SECRET || "",
    VENDOR_GUID:process.env.REACT_APP_VENDOR_GUID || "",
  },
};

export default config;
